import { useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { FaBell, FaExclamationTriangle, FaShoppingCart } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getSingleStoreItems } from "../../../redux/actions/storeInventoryAction";

const Notifications = () => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.user);

  const { singleStoreItems } = useSelector((state) => state.storeInventory);


  useEffect(() => {
    if (currentUser) {
      dispatch(getSingleStoreItems(currentUser?.store?._id));
    }
  }, [dispatch, currentUser]);

  // filter out low stock items
  const lowStockItems = singleStoreItems && singleStoreItems.filter(item => item.currentInventory > 0 && item.currentInventory < item.reorderLevel);

  // filter out out of stock items  
  const outOfStockItems = singleStoreItems && singleStoreItems.filter(item => item.currentInventory === 0);

  return (
    <div className="navbar-link">
      <Dropdown>
        <Dropdown.Toggle as="div" className="notification-toggle no-arrow cursor-pointer">
          <span className="position-relative me-3">
            <FaBell className="text-white notification-icon" />
            <span className="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill">
              {lowStockItems?.length + outOfStockItems?.length}
            </span>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu dropdown-menu-end notification-menu" style={{ minWidth: "320px" }}>
          <Dropdown.Header className='text-center text-white '>
            <strong> You have {lowStockItems?.length + outOfStockItems?.length} new notifications</strong>
          </Dropdown.Header>
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to="/admin/store-inventory" className="d-flex justify-content-between align-items-center">
            <div className="d-flex">
              <span className="position-relative me-3">
                <FaExclamationTriangle className="text-warning notification-submenu-icon" />
                <span className="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill" style={{ fontSize: "0.6rem", padding: "2px 5px" }}>
                  {lowStockItems?.length}
                </span>
              </span>
              <strong className="ms-3">Low Stock:</strong>
            </div>
            <span className="float-end fs-7">30 mins ago</span>
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to="/admin/store-inventory" className="d-flex justify-content-between align-items-center">
            <div className="d-flex">
              <span className="position-relative me-3">
                <FaExclamationTriangle className="text-danger notification-submenu-icon" />
                <span className="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill" style={{ fontSize: "0.6rem", padding: "2px 5px" }}>
                  {outOfStockItems?.length}
                </span>
              </span>
              <strong className="ms-3">Out of Stock:</strong>
            </div>
            <span className="float-end fs-7">1 hour ago</span>
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to="#" className="d-flex justify-content-between align-items-center text-start">
            <div className="d-flex">
              <span className="position-relative me-3">
                <FaShoppingCart className="text-danger notification-submenu-icon" />
                <span className="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill" style={{ fontSize: "0.6rem", padding: "2px 5px" }}>
                  {outOfStockItems?.length}
                </span>
              </span>
              <strong className="ms-3">New Orders:</strong>
            </div>
            <span className="float-end fs-7">1 hour ago</span>
          </Dropdown.Item>
          <Dropdown.Divider />
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}
export default Notifications